
import "@sparta.sb-deposits.modules/product-summary-sb-deposits-module/dist/styles.css"
import "@sparta.sb-deposits.modules/you-can-add-sb-deposits-module/dist/styles.css"
import "@sparta.sb-deposits.modules/go-to-application-sb-deposits-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import sbDepositsStylesUtility from "@sparta.sb-deposits.utilities/sb-deposits-styles-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"

import "@sparta.sb-deposits.modules/product-summary-sb-deposits-module/dist/es6.js"
import "@sparta.sb-deposits.modules/you-can-add-sb-deposits-module/dist/es6.js"
import "@sparta.sb-deposits.modules/go-to-application-sb-deposits-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run();
  console.log('after - execute boot functions')
})();
